/* ============================================================
   Silver Play — Client Correction JS  (Digital Ishtihaar)
   Loaded after the collection section's inline script, so the
   overrides below replace the buggy originals.
   - #3   Featured Products section now shows in random order
   - #11  Price range now persists after "Apply" (reads URL params)
   - #12  Browse A–Z now filters the WHOLE collection, not just
          the current paginated page, and groups by the first
          MEANINGFUL word in the title (skips "Sterling Silver"
          etc.) so products aren't all bunched under "S".
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {

    /* ---- #3  Featured Products: randomise the card order each load ----
       The "Featured Products" section (#sp-talismans) rendered its items in
       the collection's fixed saved order (pendants, then earrings). Shuffle
       the rendered cards so the display is random. Scoped to this section
       only, so other product rows are untouched. */
    try {
      document.querySelectorAll('.sp-talismans .sp-products-grid').forEach(function (fgrid) {
        var fcards = Array.prototype.slice.call(
          fgrid.querySelectorAll(':scope > .sp-product-card')
        );
        if (fcards.length < 2) return;
        for (var i = fcards.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = fcards[i]; fcards[i] = fcards[j]; fcards[j] = tmp;
        }
        var showAttr = fgrid.getAttribute('data-feat-count');
        var show = showAttr ? parseInt(showAttr, 10) : 0;
        fcards.forEach(function (c, idx) {
          c.classList.remove('sp-feat-extra');
          c.style.display = (show && idx >= show) ? 'none' : '';
          fgrid.appendChild(c);
        });
      });
    } catch (e) { /* no-op */ }


    /* ---- #4 / #5  Rename customer-facing labels ----
       Shop → Treasury, Products → Masterpieces, Pendants → Regal Pendants.
       Only matches links/buttons/headings whose visible label is EXACTLY the
       word (ignoring a trailing dropdown arrow), so phrases like
       "Shop By Occasion" or "Shop Now" are never affected. */
    try {
      var SP_RENAMES = { 'Shop': 'Treasury', 'Products': 'Masterpieces', 'Pendants': 'Regal Pendants' };
      var SP_TRAIL = /[\s▾▸▶▼❯>›→]+$/g;
      var renameLabel = function (el) {
        var stripped = el.textContent.replace(SP_TRAIL, '').trim();
        if (!Object.prototype.hasOwnProperty.call(SP_RENAMES, stripped)) return;
        var to = SP_RENAMES[stripped];
        var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var node, replaced = false;
        while ((node = tw.nextNode())) {
          if (node.nodeValue.indexOf(stripped) !== -1) {
            node.nodeValue = node.nodeValue.replace(stripped, to);
            replaced = true; break;
          }
        }
        if (!replaced && el.children.length === 0) {
          el.textContent = el.textContent.replace(stripped, to);
        }
      };
      document.querySelectorAll('a, button, .sp-coll-banner__title').forEach(renameLabel);
    } catch (e) { /* no-op */ }


    /* ---- Men's Collection in the header "Collections ▾" dropdown ----
       (Digital Ishtihaar, 19 Jul 2026) The live header's Collections menu is
       a simple thumbnail dropdown (.sp-nav__dropdown-menu with .sp-nav__dd-item
       entries: Earrings, Regal Pendants, All Jewellery) — not the mega panels
       an earlier version of this block targeted. Insert a Men's Collection
       item (thumb + label) before "All Jewellery". Also adds a "Men's
       Collection" link to the mobile drawer nav so phones get it too. */
    try {
      var MENS_URL = '/collections/mens-collection';
      var MENS_DD_IMG = 'https://cdn.shopify.com/s/files/1/0702/4456/5101/collections/Model_Image_9.png?v=1784391255&width=120';
      document.querySelectorAll('.sp-nav__dropdown-menu').forEach(function (ddMenu) {
        if (ddMenu.querySelector('a[href*="mens-collection"]')) return;
        var mensItem = document.createElement('a');
        mensItem.href = MENS_URL;
        mensItem.className = 'sp-nav__dd-item';
        mensItem.innerHTML =
          '<img class="sp-nav__dd-thumb" src="' + MENS_DD_IMG + '" alt="" loading="lazy">' +
          '<span>Men&#39;s Collection</span>';
        var allItem = Array.prototype.filter.call(
          ddMenu.querySelectorAll('.sp-nav__dd-item'),
          function (x) { return x.getAttribute('href') === '/collections/all'; }
        )[0];
        if (allItem) { ddMenu.insertBefore(mensItem, allItem); }
        else { ddMenu.appendChild(mensItem); }
      });
      var drawerNav = document.querySelector('.sp-mobile-menu__nav');
      if (drawerNav && !drawerNav.querySelector('a[href="' + MENS_URL + '"]')) {
        var drawerSep = drawerNav.querySelector('.sp-mobile-menu__sep');
        var mensLink = document.createElement('a');
        mensLink.href = MENS_URL;
        mensLink.textContent = "Men's Collection";
        mensLink.addEventListener('click', function () {
          if (typeof closeMenu === 'function') closeMenu();
        });
        if (drawerSep) { drawerNav.insertBefore(mensLink, drawerSep); }
        else { drawerNav.appendChild(mensLink); }
      }
    } catch (e) { /* no-op */ }


    /* ---- Homepage benefits marquee: remove unverified claims, add savings promise ----
       (Digital Ishtihaar, 19-20 Jul 2026) 1) Removes the "BIS Hallmarked" and
       "Hypoallergenic" items — the brand doesn't hold those certifications, so
       they must not be claimed anywhere. 2) Adds "Savings With Every Purchase"
       and "Buy Silver At The Same Rate For 6 Months". The section renders its
       blocks 4x for a seamless -50% loop, so removals/additions are applied
       uniformly across every copy to keep the animation seamless. Skips the
       Sanskrit mantra marquee. */
    try {
      var SAVE_TXTS = ['Savings With Every Purchase', 'Buy Silver At The Same Rate For 6 Months'];
      document.querySelectorAll('.sp-marquee__track').forEach(function (track) {
        if (track.textContent.indexOf('925 Sterling Silver') === -1) return;
        Array.prototype.slice.call(track.querySelectorAll(':scope > .sp-marquee__item')).forEach(function (it) {
          if (/BIS Hallmark|Hypoallergenic/i.test(it.textContent)) { track.removeChild(it); }
        });
        if (track.textContent.indexOf(SAVE_TXTS[0]) !== -1) return;
        var items = Array.prototype.slice.call(track.querySelectorAll(':scope > .sp-marquee__item'));
        if (!items.length) return;
        var copies = 4;
        var unique = items.length / copies;
        if (unique !== Math.floor(unique)) { copies = 1; unique = items.length; }
        var proto = items[0];
        var makeItem = function (txt) {
          var s = proto.cloneNode(true);
          Array.prototype.slice.call(s.childNodes).forEach(function (n) {
            if (n.nodeType === 3) { s.removeChild(n); }
          });
          s.appendChild(document.createTextNode(txt));
          return s;
        };
        for (var c = copies - 1; c >= 0; c--) {
          var anchor = items[(c + 1) * unique - 1];
          var ref = anchor.nextSibling;
          for (var k = 0; k < SAVE_TXTS.length; k++) {
            track.insertBefore(makeItem(SAVE_TXTS[k]), ref);
          }
        }
      });
    } catch (e) { /* no-op */ }


    /* ---- Subtitle / eyebrow follows the per-section "Body size" ----
       (Digital Ishtihaar, 18 Jul 2026) In Brand Story the subtitle (eyebrow)
       is a <span class="sp-story__eyebrow-text"> with a hardcoded 11px size,
       and in Featured Products the eyebrow/subheading fight the base styles —
       so the Customizer's per-section "Body size" slider never changed them.
       Fix: read each section's emitted `#sp-… p,#sp-… li{font-size:NNpx}`
       typography rule and mirror the same size onto the eyebrow/subtitle
       elements with !important. Re-applies on Customizer section reloads. */
    function spApplySubtitleSizes() {
      try {
        var css = '';
        document.querySelectorAll('style').forEach(function (st) {
          if (st.id === 'sp-subtitle-size-fix') return;
          var re = /#sp-([A-Za-z0-9_-]+) p,#sp-\1 li\{font-size:(\d+)px;\}/g;
          var m;
          while ((m = re.exec(st.textContent))) {
            css += '#sp-' + m[1] + ' .sp-story__eyebrow-text,' +
                   '#sp-' + m[1] + ' .sp-eyebrow,' +
                   '#sp-' + m[1] + ' .sp-section-head p' +
                   '{font-size:' + m[2] + 'px !important;}';
          }
        });
        var tag = document.getElementById('sp-subtitle-size-fix');
        if (!tag) {
          tag = document.createElement('style');
          tag.id = 'sp-subtitle-size-fix';
          document.head.appendChild(tag);
        }
        tag.textContent = css;
      } catch (e) { /* no-op */ }
    }
    spApplySubtitleSizes();
    document.addEventListener('shopify:section:load', function () {
      setTimeout(spApplySubtitleSizes, 60);
    });


    /* ---- #11  Restore price sliders from the active URL filter ---- */
    try {
      var params   = new URLSearchParams(window.location.search);
      var gte      = params.get('filter.v.price.gte');
      var lte      = params.get('filter.v.price.lte');
      var minInput = document.getElementById('sp-price-min-input');
      var maxInput = document.getElementById('sp-price-max-input');

      if (minInput && gte !== null && gte !== '') {
        minInput.value = gte;
        minInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (maxInput && lte !== null && lte !== '') {
        maxInput.value = lte;
        maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } catch (e) { /* no-op */ }


    /* ---- #12  Browse A–Z across the whole collection ---- */
    var grid = document.getElementById('sp-coll-grid');
    if (!grid) return;

    // Leading words that shouldn't decide the A–Z bucket.
    var SKIP_WORDS = {
      'sterling': 1, 'silver': 1, 'the': 1, 'a': 1, 'an': 1,
      '925': 1, '92.5': 1, 'pure': 1
    };

    // First letter of the first meaningful word in the title.
    function meaningfulFirstLetter(title) {
      if (!title) return '';
      var words = String(title).trim().split(/\s+/);
      var i = 0;
      // Skip filler words, but never skip the very last word.
      while (i < words.length - 1) {
        var w = words[i].toLowerCase().replace(/[^a-z0-9.]/g, '');
        if (SKIP_WORDS[w]) { i++; } else { break; }
      }
      for (var j = i; j < words.length; j++) {
        var m = words[j].match(/[A-Za-z]/);
        if (m) return m[0].toUpperCase();
      }
      var fm = String(title).match(/[A-Za-z]/);
      return fm ? fm[0].toUpperCase() : '';
    }

    function titleOf(card) {
      return card.getAttribute('data-product-name') ||
             card.getAttribute('data-title') ||
             (card.querySelector('.sp-coll-card__name') || {}).textContent || '';
    }

    // Recompute each card's bucket letter from its title.
    function normalizeLetters(root) {
      (root || grid).querySelectorAll('.sp-coll-card').forEach(function (card) {
        var L = meaningfulFirstLetter(titleOf(card));
        if (L) card.dataset.firstLetter = L;
      });
    }

    // Dim letter buttons that have no products (once the full set is known).
    function markAvailableLetters() {
      var present = {};
      grid.querySelectorAll('.sp-coll-card').forEach(function (c) {
        if (c.dataset.firstLetter) present[c.dataset.firstLetter] = 1;
      });
      document.querySelectorAll('.sp-alpha-btn').forEach(function (b) {
        if (b.classList.contains('sp-alpha-btn--clear')) return;
        var L = b.getAttribute('data-letter');
        if (L && !present[L]) {
          b.disabled = true;
          b.style.opacity = '0.3';
          b.style.pointerEvents = 'none';
          b.title = 'No products';
        } else {
          b.disabled = false;
          b.style.opacity = '';
          b.style.pointerEvents = '';
          b.removeAttribute('title');
        }
      });
    }

    // Normalise the letters on the cards already on the page.
    normalizeLetters(grid);

    function collectionHandle() {
      var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
      return m ? m[1] : null;
    }

    // Pull every page of the collection once, so the grid holds all cards.
    async function ensureAllCardsLoaded() {
      if (grid.dataset.spAllLoaded === '1') return;
      var handle = collectionHandle();
      if (!handle) { grid.dataset.spAllLoaded = '1'; return; }

      var collected = [];
      for (var page = 1; page <= 25; page++) {
        var url = '/collections/' + handle + '?page=' + page;
        var resp;
        try { resp = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } }); }
        catch (err) { break; }
        if (!resp.ok) break;
        var html = await resp.text();
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('#sp-coll-grid .sp-coll-card');
        if (!cards.length) break;
        cards.forEach(function (c) { collected.push(document.importNode(c, true)); });
      }

      if (collected.length) {
        grid.innerHTML = '';
        collected.forEach(function (c) { grid.appendChild(c); });
      }
      normalizeLetters(grid);
      grid.dataset.spAllLoaded = '1';

      // Page numbers no longer apply once everything is in one grid.
      var pager = document.querySelector('.sp-pagination');
      if (pager) pager.style.display = 'none';

      markAvailableLetters();
    }

    // Override the section's page-only version with a catalog-wide one.
    window.spFilterAlpha = async function (letter, btn) {
      document.querySelectorAll('.sp-alpha-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      if (btn) btn.classList.add('is-active');

      await ensureAllCardsLoaded();

      var cards = grid.querySelectorAll('.sp-coll-card');
      var count = 0;
      cards.forEach(function (card) {
        if (!letter || card.dataset.firstLetter === letter) {
          card.style.display = '';
          count++;
        } else {
          card.style.display = 'none';
        }
      });
      var countEl = document.getElementById('sp-prod-count');
      if (countEl) countEl.textContent = count;
    };

    /* ---- #3 (Shop page)  Randomise the all-products grid ----
       On the Shop / "Treasury" listing the products showed pendants first,
       then earrings. Load the whole catalog once and shuffle so it's a random
       mix. Only on /collections/all and /collections/pendants with NO active filter/sort (the !search
       guard keeps A–Z ?letter=, ?sort_by=, price filters and ?page= untouched). */
    if (/^\/collections\/(all|pendants)\/?$/.test(window.location.pathname) && !window.location.search) {
      (function () {
        var vis = Array.prototype.slice.call(grid.querySelectorAll('.sp-coll-card'));
        for (var vk = vis.length - 1; vk > 0; vk--) {
          var vm = Math.floor(Math.random() * (vk + 1));
          var vt = vis[vk]; vis[vk] = vis[vm]; vis[vm] = vt;
        }
        vis.forEach(function (c) { grid.appendChild(c); });
      })();
      ensureAllCardsLoaded().then(function () {
        var all = Array.prototype.slice.call(grid.querySelectorAll('.sp-coll-card'));

        // Keep only products that actually have a photo (drafts are already
        // excluded by the storefront; this drops blank-image cards too).
        var hasImage = function (c) {
          var d = c.getAttribute('data-product-img') || '';
          if (d && !/no[-_]?image|placeholder/i.test(d)) return true;
          var img = c.querySelector('img');
          if (img) {
            var src = img.getAttribute('src') || img.getAttribute('data-src') ||
                      img.getAttribute('srcset') || '';
            if (src && !/no[-_]?image|placeholder|\.svg/i.test(src)) return true;
          }
          return false;
        };

        var keep = [], drop = [];
        all.forEach(function (c) { (hasImage(c) ? keep : drop).push(c); });
        drop.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });

        for (var s = keep.length - 1; s > 0; s--) {
          var r = Math.floor(Math.random() * (s + 1));
          var sw = keep[s]; keep[s] = keep[r]; keep[r] = sw;
        }
        keep.forEach(function (c) { grid.appendChild(c); });

        var ce = document.getElementById('sp-prod-count');
        if (ce) ce.textContent = keep.length;
      });
    }
  });


  /* ============================================================
     30 Jul 2026 fixes (Digital Ishtihaar) — verified against a
     vendor audit (CreativeHonchos):

     B) Cart badge / drawer never update after an AJAX "Add to
        Bag" click (collection grid quick-add, "You May Like
        This" cross-sell, "Recently Viewed" quick-add). Each of
        those buttons independently calls fetch('/cart/add.js',
        ...); the collection-grid one tries to refresh the header
        count itself but its selector never matches the header's
        real markup, so the badge and the cart drawer both stay
        frozen at whatever they were when the page first loaded
        until the shopper manually reloads or navigates to /cart.
        Fix: wrap window.fetch once so ANY successful call to
        /cart/add(.js) anywhere on the site refreshes the header
        badge and rebuilds the drawer's item list + total from
        live /cart.js data — covers today's quick-add buttons and
        any future ones without editing each one individually.

     C) "Recently Viewed" quick-add button calls a spQuickAdd()
        function that was never defined anywhere in the theme, so
        clicking it silently did nothing (JS ReferenceError). Add
        the missing implementation.

     NOTE: an earlier version of this patch also repointed
     "Explore All Collection" buttons to /collections/all — the
     client asked for that to be reverted (30 Jul 2026), so those
     buttons keep their original themed sub-collection links
     (Gen-Z, Spotlight Glam) and no rewrite is applied here.
     ============================================================ */
  ready(function () {

    /* ---- Cart badge + drawer real-time sync ---- */
    function spSetCartCount(n) {
      try {
        document.querySelectorAll('[aria-label="Cart"]').forEach(function (btn) {
          Array.prototype.forEach.call(btn.childNodes, function (node) {
            if (node.nodeType === 3 && /\(\s*\d+\s*\)/.test(node.nodeValue)) {
              node.nodeValue = node.nodeValue.replace(/\(\s*\d+\s*\)/, '(' + n + ')');
            }
          });
        });
        var title = document.querySelector('.sp-cart-drawer__title');
        if (title) { title.textContent = 'Your Bag (' + n + ')'; }
      } catch (e) { /* no-op */ }
    }

    function spFmtRupees(cents) {
      return (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    function spRenderCartDrawer(cart) {
      try {
        var itemsWrap = document.querySelector('.sp-cart-drawer__items');
        if (!itemsWrap) return;
        var oldFooter = document.querySelector('.sp-cart-drawer__footer');

        if (!cart.items || !cart.items.length) {
          itemsWrap.innerHTML =
            '<div class="sp-cart-drawer__empty">' +
              '<p>Your bag is empty.</p>' +
              '<a href="/collections/all" class="btn btn-gold" onclick="closeCart()">Browse Jewellery</a>' +
            '</div>';
          if (oldFooter) oldFooter.parentNode.removeChild(oldFooter);
          return;
        }

        itemsWrap.innerHTML = cart.items.map(function (item, idx) {
          var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p style="font-size:0.8rem;color:var(--text-3);margin-bottom:0.25rem;">' + item.variant_title + '</p>'
            : '';
          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="" loading="lazy">'
            : '';
          return '<div class="sp-cart-item">' +
            '<div class="sp-cart-item__img">' + imgHtml + '</div>' +
            '<div>' +
              '<p class="sp-cart-item__name">' + item.product_title + '</p>' +
              variantLine +
              '<p class="sp-cart-item__price">₹' + spFmtRupees(item.line_price) + '</p>' +
              '<a href="/cart/change?line=' + (idx + 1) + '&quantity=0" class="sp-cart-item__remove">Remove</a>' +
            '</div></div>';
        }).join('');

        var footer = oldFooter;
        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'sp-cart-drawer__footer';
          itemsWrap.parentNode.insertBefore(footer, itemsWrap.nextSibling);
        }
        footer.innerHTML =
          '<div class="sp-cart-drawer__total">' +
            '<span class="sp-cart-drawer__total-label">Total</span>' +
            '<span class="sp-cart-drawer__total-price">₹' + spFmtRupees(cart.total_price) + '</span>' +
          '</div>' +
          '<p class="sp-cart-drawer__note">Taxes &amp; shipping calculated at checkout</p>' +
          '<form action="/cart" method="post" style="margin:0;width:100%;"><button type="submit" name="checkout" class="btn btn-gold" style="width:100%;justify-content:center;margin-bottom:0.75rem;">Proceed to Checkout</button></form>' +
          '<a href="/cart" style="display:block;text-align:center;font-family:var(--font-display);font-size:10px;letter-spacing:0.25em;text-transform:uppercase;color:var(--text-3);">View Full Bag</a>';
      } catch (e) { /* no-op */ }
    }

    function spRefreshCartUI() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          spSetCartCount(cart.item_count);
          spRenderCartDrawer(cart);
          return cart;
        })
        .catch(function () { /* no-op */ });
    }
    window.spRefreshCartUI = spRefreshCartUI;

    try {
      var _spOrigFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        var isAdd = url.indexOf('/cart/add') !== -1;
        return _spOrigFetch.apply(this, arguments).then(function (res) {
          if (isAdd && res && res.ok) { spRefreshCartUI(); }
          return res;
        });
      };
    } catch (e) { /* no-op */ }

    /* ---- Recently Viewed quick-add — was calling an undefined function ---- */
    window.spQuickAdd = function (btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Unavailable';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      });
    };
    try{document.addEventListener('submit',function(e){var form=e.target;if(!(form instanceof HTMLFormElement))return;var action=form.getAttribute('action')||'';if(action.indexOf('/cart/add')===-1)return;var rt=form.querySelector('input[name="return_to"]');if(!rt||rt.value.indexOf('/checkout')===-1)return;e.preventDefault();var btn=form.querySelector('button[type="submit"], button:not([type])');var origText=btn?btn.textContent:null;if(btn){btn.disabled=true;btn.textContent='Processing...';}var fd=new FormData(form);fd.delete('return_to');fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){if(!r.ok)throw new Error('add failed');return r.json();}).then(function(){var f=document.createElement('form');f.action='/cart';f.method='post';f.style.display='none';var b=document.createElement('button');b.type='submit';b.name='checkout';f.appendChild(b);document.body.appendChild(f);if(f.requestSubmit){f.requestSubmit(b);}else{b.click();}}).catch(function(){if(btn){btn.textContent='Unavailable';setTimeout(function(){btn.disabled=false;btn.textContent=origText;},1800);}});},true);}catch(e){}
  });
})();
